<div class="depoimentos-item">
  <div class="person">
    <div class="person-avatar">
      <div 
        class="avatar"
        [ngStyle]="{ 'background-image': 'url(' + avatar + ')' }"
        ></div>
    </div>

    <div class="description">
      <h5 class="name">{{ name }}</h5>
      <p class="specialty">{{ specialty }}</p>

      <div class="rating">
        <!-- <div
          class="star"
          [ngClass]="{ off: rate > $index }"
          *ngFor="let rate of [].constructor(5)"
        ></div> -->
      </div>
    </div>
  </div>

  <p class="content">{{ content }}</p>
</div>
